// extracted by mini-css-extract-plugin
module.exports = {"careerRecommendJobList__validationMessageList":"careerRecommendJobList__validationMessageList"};